module.exports = __webpack_public_path__ + "img/workflow-header-icon.a9ac823a.svg";